import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { IResidentAdvice, INursingHomeAdvice } from '../_interfaces';

@Injectable()
export class ResidentAdviceService {
  constructor(private http: HttpService) {
  }

  fetchAdviceByNursingHome(nursingHomeId: number, from: string = null, to: string = null, limit = 10000): Observable<INursingHomeAdvice[]> {
    let params: { [key: string]: any } = {};
    if (from) {
      params = {...params, from: from};
    }
    if (to) {
      params = {...params, to: to};
    }
    if (limit) {
      params = {...params, limit: limit};
    }
    return this.http.get(`/api/v2/pro/nursing-homes/${nursingHomeId}/advices`, params);
  }

  fetchAdviceByResident(residentId: number, from: string = null, to: string = null, limit = 10000): Observable<IResidentAdvice[]> {
    let params: { [key: string]: any } = {};
    if (from) {
      params = {...params, from: from};
    }
    if (to) {
      params = {...params, to: to};
    }
    if (limit) {
      params = {...params, limit: limit};
    }
    return this.http.get(`/api/v2/pro/residents/${residentId}/advices`, params);
  }

  createResidentAdvice(params: Partial<IResidentAdvice>, residentId: number) {
    return this.http.post(`/api/v2/pro/residents/${residentId}/advices`, params);
  }

  deleteResientAdvice(residentId: number, adviceId: number) {
    return this.http.delete(`/api/v2/pro/residents/${residentId}/advices/${adviceId}`);
  }

  editResidentAdvice(params: Partial<IResidentAdvice>, residentId: number, adviceId: number) {
    return this.http.put(`/api/v2/pro/residents/${residentId}/advices/${adviceId}`, params);
  }

  fetchResidentAdvice(residentId: number, adviceId: number): Observable<IResidentAdvice> {
    return this.http.get(`/api/v2/pro/residents/${residentId}/advices/${adviceId}`);
  }
}
